import React from 'react';
import PropTypes from 'prop-types';
import SelectFilter from './Filters/SelectFilter';
import i18n from "../i18n/translate";

const APP_OPTIONS = Object.freeze([
  {
    slug: 'train',
    group: 'Train',
    label: i18n.t('Train'),
    details: i18n.t('Assign and manage learning'),
    icon: 'train'
  },
  {
    slug: 'learn',
    group: 'Learn',
    label: i18n.t('Learn'),
    details: i18n.t('Complete training assigned to you'),
    icon: 'learn'
  },
  {
    slug: 'impact',
    group: 'Impact',
    label: i18n.t('Impact'),
    details: i18n.t('View the impact of initiatives'),
    icon: 'impact'
  },
  {
    slug: 'promote',
    group: 'Promote',
    label: i18n.t('Promote'),
    details: i18n.t('Manage marketing programs'),
    icon: 'promote'
  },
  {
    slug: 'engage',
    group: 'Engage',
    label: i18n.t('Engage'),
    details: i18n.t('Manage webinars and in-person events'),
    icon: 'engage'
  }
]);

const HeaderMenuAppSwitcher = ({ currentRuleSets = [], menuItems = [], onRedirect }) => {
  const activeRuleSet = currentRuleSets.find(currentRuleSet => currentRuleSet.active) || {};
  const availableApps = APP_OPTIONS.filter(appOption => menuItems.some(menuItem => menuItem.slug === appOption.slug));
  const defaultApp = availableApps.find(appOption => appOption.group === activeRuleSet.interstitial_group);
  const onChange = selectedApp => {
    const menuItem = menuItems.find(menuItem => menuItem.slug === selectedApp.slug);
    if (menuItem) {
      onRedirect(menuItem.target_url);
    }
  };

  // no appswitcher if there is not more that one train role to choose from
  if (availableApps.length < 2) {
    return null;
  } else {
    return (
      <div className="header-menu-app-switcher">
        <SelectFilter
          clearable={false}
          defaultValue={defaultApp}
          explainerKey="details"
          iconFamily="fi-icon"
          iconKey="icon"
          onChange={onChange}
          options={availableApps}
          showSelected={true}
          valueKey="group" />
      </div>
    );
  }
}

HeaderMenuAppSwitcher.propTypes = {
  currentRuleSets: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      interstitial_group: PropTypes.string
    })
  ),
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      target_url: PropTypes.string
    })
  ),
  onRedirect: PropTypes.func
};

export default HeaderMenuAppSwitcher;
